export default () => import(/* webpackChunkName: 'coffee/activities/luckincard/renew-list' */ './RenewList');
